import PasswordsService from '@/api/PasswordsService.js'
import Vue from 'vue'
export const passwordsModule = {
  namespaced: true,
  state: () => ({
    passwordsData: [],
    passwordsLoadStatus: 'request',
    paginationPasswordsStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPasswordsStateParams.total /
        state.paginationPasswordsStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.passwordsData = [...data]
    },
    create(state, data) {
      state.passwordsData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.passwordsData.findIndex(
        (x) => x.book_passwords__id == data.id
      )
      Object.assign(state.passwordsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.passwordsData.findIndex(
        (x) => x.book_passwords__id == id
      )
      state.passwordsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPasswordsStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.passwordsLoadStatus = 'request'
    },
    load_success(state) {
      state.passwordsLoadStatus = 'success'
    },
    load_error(state) {
      state.passwordsLoadStatus = 'error'
    }
  },
  actions: {
    setPasswordsRoute({ commit }, route) {
      PasswordsService.setRoute(route)
    },

    getPasswordsAll({ commit }, params) {
      commit('load_request')

      PasswordsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createPasswordsData({ commit }, createData) {
      PasswordsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editPasswordsMultiple({ commit }, { id, dataEdit }) {
      PasswordsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deletePasswordsData({ commit }, id) {
      // commit("load_request");
      PasswordsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
